/*
 * Copyright (c) 2021 Daimler AG. All rights reserved.
 * Implemented 2021 by DCCS GmbH.
 */

import BaseFormatter, { FormatterProperties } from './BaseFormatter';

/**
 * Custom properties for number formatter.
 */
interface NumberFormatterProperties extends FormatterProperties {
  decimalPlaces?: number;
  minIntegerDigits?: number;
}

/**
 * Formats various field types for displaying them on the views, per user's locale (where applicable).
 */
export const NumberFormatter: BaseFormatter<number, NumberFormatterProperties> = {
  format: (value?: number, props: NumberFormatterProperties = {}): string => {
    if (!value || isNaN(value)) {
      return '';
    }

    return value.toLocaleString('de', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  },
  parse: (value?: string): number | undefined => {
    if (value) {
      const parsedNumber = parseFloat(value.replace(',', '.'));
      return !isNaN(parsedNumber) ? parsedNumber : undefined;
    }
  },
};
